import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import { ComposableMap, ZoomableGroup, Geographies,Geography,Marker} from "react-simple-maps";
import {Button, Modal, Dropdown} from 'semantic-ui-react';

import {Redirect} from 'react-router';
import data from '../../assets/json/destinations/WorldMap.json';
import markers from '../../assets/json/destinations/markers.json';
import description from '../../assets/json/destinations/description.json';

export default class WorldMap extends Component{

	constructor(props) {
		super(props);
		this.state = {
			markers: markers.markers,
			description: description.countries,
			countryname:"",
			countrydesc:"",
			status: "",
			href:'',
			open: false,
			redirect: false,
			routeLink: '',
			continent: '',
			longlat:[195,138]
		}
	}


	handleClose = () => {
		this.setState({ 
			open: false
		});
	}
	
	goToContactUs = () => {
		this.setState({
			redirect: true,
			routeLink: '/contactus'
		});
	}

	onCountryClick = (geography, i) =>{
		
		this.setState({open: true});

		const itemCount = Object.keys(this.state.description).length;
		let d = this.state.description;
		for (var index = 0; index < itemCount; ++index) {
		  var dsc = this.state.description[index];
		  if(dsc.id === geography.id){
			  d[index].active = "true";
		  }
		  else{
			  d[index].active = "false";
		  }
		}
		this.setState({description: d});
		for (var ind = 0; ind < itemCount; ++ind) {

			var place = this.state.description[ind];
			if (place.id === geography.id){
				
				this.setState({
					countryname: place.name,
					countrydesc: place.desc,
					status: place.status,
					href: place.href
				});
				
				break;
			}
		}
		
	}

	getContinent = (value) => {
		if(value === 'Europe'){
			this.setState({
				longlat:[195,138],
				continent: value
			});
		}
		else if(value === 'Asia'){
			this.setState({
				longlat:[100.9925385, 15.8700323],
				continent: value
			});
		}
		else if(value === 'Africa'){
			this.setState({
				longlat:[27.849333, -13.133897],
				continent: value
			});
		}
		else if(value === 'Australia'){
			this.setState({
				longlat:[133.7751312, -25.2743988],
				continent: value
			});
		}
		else if(value === 'North America'){
			this.setState({
				longlat:[-95.7128906, 37.0902405],
				continent: value
			});
		}
		else if(value === 'South America'){
			this.setState({
				longlat:[-75.015152, -9.1899672],
				continent: value
			});
		}
		else{
			this.setState({
				longlat:[135.000000, -82.862755],
				continent: value
			});
		}
	}

	render(){
		let {redirect, routeLink, continent, longlat} = this.state;
		return (
			<>
				{ redirect &&
					<Redirect push to={routeLink}/>
				}

				<Modal open={this.state.open} onClose={this.handleClose} size='small' className="modalDestination" closeIcon dimmer='blurring' closeOnDimmerClick={false}>
					<Modal.Header>{this.state.countryname}</Modal.Header>
					<Modal.Content>
						<p className="para-content">
							{this.state.countrydesc}
						</p>
						<p className="para-content para-content-blue">
							{this.state.status}
						</p>
					</Modal.Content>
					<Modal.Actions>
					{this.state.status === "" ?
						<NavLink className="ui orange button" to={this.state.href}>See tour details</NavLink>
					:
						<Button color='orange' onClick={this.goToContactUs} >Contact us</Button>
					}
					
				</Modal.Actions>
				</Modal>

				<div className='continent-wrapper'>
					<Dropdown
						selection
						label="I want to go to"
						options={[
							{key:0, value:'Europe', text:'Europe'},
							{key:1, value:'Asia', text:'Asia'},
							{key:2, value:'Africa', text:'Africa'},
							{key:3, value:'Australia', text:'Australia'},
							{key:4, value:'North America', text:'North America'},
							{key:5, value:'South America', text:'South America'},
							{key:6, value:'Antarctica', text:'Antarctica'},
						]}
						placeholder="I want to go to"
						size="mini"
						value={continent}
						fluid
						//onChange={(e,d) => this.setState({continent: d.value})}
						onChange={(e,d) => this.getContinent(d.value)}
					/>
				</div>
				<ComposableMap 
					projectionConfig={{
						scale: 450,
						rotate: [-20.0, -30.0, 0],
					}}
					style={{
						minWidth: "1440px",
						fill: "#4d4d4d",
						stroke: "#3a3a3a"
					}}
				>
					<ZoomableGroup center={longlat} zoom={1.3} disablePanning={false}>
						<Geographies geography={data}>
							{({ geographies}) => geographies.map((geography, i) => (
								<Geography 
									key={i} 
									geography={geography} 
									style={{
										default: {
										strokeWidth: 0.5,
										outline: "none",
										
										},
										hover: {
										strokeWidth: 0.5,
										outline: "none",
										},
										pressed: {
										strokeWidth: 0.5,
										outline: "none",
										}
									}}
								/>
							))}
						</Geographies>
						{this.state.markers.map((marker, i) => (
							<Marker 
								key={marker.name} 
								coordinates={marker.coordinates}
								onClick={() => this.onCountryClick(marker, i)}
								style={{
								default: { stroke: "#f39926",
											fill:   "#f39926"},
								hover:   { stroke: "#f39926",
											fill:   "#FFFFFF"},
								pressed: { stroke: "#f39926",
											fill:   "#FFFFFF"}
								}}
							>
								<circle cx="3" cy="-12" r="2.3"/>
								<text
									textAnchor="middle"
									x={marker.XOffset}
									y={marker.YOffset}
									style={{
										fontFamily: "Roboto, sans-serif",
										fill: "#ffffff",
										stroke: "#ffffff",
										strokeWidth: "0",
										fontStyle: "bold",
										fontSize: "7px"
									}}
									>
									{marker.name}
								</text>
							</Marker>
						))}
					</ZoomableGroup>
				</ComposableMap>
			</>
		);
	}
}
